<div class="d-flex p-2">
    <div class="me-auto">
        <b>{{title}}</b>
    </div>
    <div>
        <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>

    </div>
</div>
<div class="d-flex justify-content-around p-5">
    <img [src]="imageSrc" class="img-fluid" />
</div>
